module.exports = __webpack_public_path__ + "static/media/paraffin_900_detail.576789c0.jpg";